var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXmo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32566)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#FF6600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.75 8.99996C15.75 12.7282 12.7282 15.75 9 15.75C5.27175 15.75 2.25 12.7282 2.25 8.99996C2.25 7.49189 2.74556 6.09971 3.57862 4.97639L4.68112 6.07889C4.09575 6.94048 3.78332 7.95833 3.7845 8.99996C3.7845 11.8743 6.12056 14.2098 8.99494 14.2098C11.8688 14.2098 14.2048 11.8738 14.2048 8.99996C14.2044 7.9584 13.8921 6.94083 13.3082 6.07833L14.4107 4.97583C15.283 6.13581 15.7532 7.54861 15.75 8.99996Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7333 8.99994C12.7323 9.98976 12.3386 10.9387 11.6387 11.6386C10.9388 12.3385 9.9898 12.7322 8.99999 12.7333C8.01007 12.7324 7.06095 12.3388 6.36092 11.6388C5.6609 10.9389 5.26716 9.98986 5.26611 8.99994C5.26611 8.35138 5.43486 7.71351 5.75661 7.14932L8.99999 10.3916L12.2434 7.14819C12.565 7.71235 12.734 8.35056 12.7339 8.99994",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4139 3.89533L9 8.30365L5.63568 4.94496L4.58606 3.89533C5.80961 2.83052 7.378 2.2459 9 2.25002C10.6875 2.25002 12.2276 2.86708 13.4139 3.89533Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32566"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXmo);
export default __webpack_public_path__ + "static/media/xmo.da4bbfd3d9efdcac1aeb9f5f8a784783.svg";
export { ForwardRef as ReactComponent };